export const EnginePendingDeletionMessage = (): JSX.Element => (
  <div className="text-center m-6">
    <div>
      <h2>The data for this submission part is currently being refreshed and cannot be accessed at this time</h2>
      <p>Please wait a few moments and then refresh this page to try again</p>
    </div>
  </div>
);
